import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TActivityHis, TActivityList } from "../../../context/ActivityProvider";
import { PaginationTable } from "../../table/PaginationTable";
import { Table } from "../../table/Table";
import NotActivityFound from "../NotActivityFound";
import { BodyTableHisLogs } from "./BodyTableHisLogs";


export interface TableActivityProps {
  offset: number;
  setOffset: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  activityList: TActivityList;
  filterNotFound: boolean;
}

export const TableHisLogs = ({
  activityList,
  limit,
  offset,
  setLimit,
  setOffset,
}: TableActivityProps): JSX.Element => {
  const { t } = useTranslation();

  const i18n = (key: string) => t(`activity-directory.table.header.${key}`);

  const isPagination = useMemo(
    () => (activityList?.count ?? 0) > 10,
    [activityList?.count]
  );

  const columns = useMemo(
    () => [
      { id: "timestamp", label: i18n("timestamp") },
      { id: "user", label: i18n("user") },
      { id: "endpoint", label: i18n("endpoint") },
      { id: "request_id", label: i18n("request_id") },
      { id: "request_status", label: i18n("request_status") },
      { id: "response_status", label: i18n("response_status") },
      { id: "error_details", label: i18n("error_details") },
    ],
    [t]
  );

  const hasNoData = activityList.count === 0;

  return (
    <div className="relative">
      {isPagination && (
        <PaginationTable
          limit={limit}
          setLimit={setLimit}
          total={activityList?.count ?? 0}
          offset={offset}
          setOffset={setOffset}
        />
      )}

      <Table columns={columns}>
        {hasNoData ? (
          <tr>
            <td colSpan={columns.length} className="text-center py-4">
              <NotActivityFound />
            </td>
          </tr>
        ) : (
          <BodyTableHisLogs
            rows={activityList.results as TActivityHis[]}
            isPagination={isPagination}
            isLoadingSendInvitation={false}
            handleClickInviteButton={() => {}}
          />
        )}
      </Table>
    </div>
  );
};
